import { render, staticRenderFns } from "./LabourRatesForm.vue?vue&type=template&id=031b45bd&"
import script from "./LabourRatesForm.vue?vue&type=script&lang=js&"
export * from "./LabourRatesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports